import { actionTypes, tabIDs } from './constants';
import { actionTypes as renameAssetActionTypes } from './Header/RenameAsset/constants';
import { apiCallStatus } from 'helpers/constants';
import { actionTypes as headerActionTypes } from './Header/constants';

const initialState = {
    activeTab: tabIDs.assetDetails,
    activeTabV2: tabIDs.summary,
    assetDetails: {
        data: null,
        error: null,
        loadingStatus: null,
    },
    renameAsset: {
        loadingStatus: apiCallStatus.SUCCESS
    },
    renamedAsset: null,
    selectedMenuItem: null,
    conditionInsightAssetStatus: {
        isConditionInsightAvailable: false,
        conditionStatus: null,
        assetId: null
    }
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_ASSET_DETAILS: {
            return {
                ...state,
                assetDetails: { ...action }
            };
        }
        case renameAssetActionTypes.UPDATE_ASSET_RENAME: {
            return {
                ...state,
                renameAsset: {
                    ...state.renameAsset,
                    loadingStatus: action.loadingStatus
                }
            };
        }
        case renameAssetActionTypes.UPDATE_ASSET_RENAME_SUCCESS: {
            return {
                ...state,
                assetDetails: {
                    ...state.assetDetails,
                    data: {
                        ...state.assetDetails.data,
                        details: {
                            ...state.assetDetails.data.details,
                            assetName: action?.data?.name
                        },
                    }
                }
            };
        }
        case renameAssetActionTypes.CLOSE_DIALOGUE: {
            return {
                ...state,
                renamedAsset: action.data.reName
            };
        }
        case headerActionTypes.SELECT_MENU_ITEM: {
            return {
                ...state,
                selectedMenuItem: action.selectedMenuItem
            };
        }
        case actionTypes.CLEAR_STORE: {
            return {
                ...state,
                assetDetails: { ...initialState.assetDetails },
                selectedMenuItem: initialState.selectedMenuItem
            };
        }
        case actionTypes.SET_ACTIVE_TAB: {
            return {
                ...state,
                activeTab: action.activeTab
            };
        }
        case actionTypes.SET_ACTIVE_TAB_V2: {
            return {
                ...state,
                activeTabV2: action.activeTab
            };
        }
        case actionTypes.SET_SELECTED_ASSET_CONDITION_INSIGHTS_STATUS: {
            return {
                ...state,
                conditionInsightAssetStatus: action.conditionInsightStatus
            };
        }
        case headerActionTypes.CLEAR_STORE: {
            return {
                ...state,
                selectedMenuItem: initialState.selectedMenuItem
            };
        }

        default:
            return state;
    }
};
